import StyledConfirmationModal from './StyledConfirmationModal'

const ConfirmationModal = props => (
  <StyledConfirmationModal {...props} />
)

export default ConfirmationModal
